const loadScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export async function openRazorpay(b, { onSuccess, onDismiss, onFail }) {
  if (!(await loadScript())) return onFail("Could not load the payment window. Please try again.");
  const rzp = new window.Razorpay({
    key: b.razorpay_key_id,
    amount: b.amount_paise,
    currency: "INR",
    name: "Smileton Dental",
    description: `Consultation · ${b.visit_reason_title}`,
    order_id: b.razorpay_order_id,
    prefill: { name: b.patient_name, contact: `+91${b.patient_phone}`, email: b.patient_email || undefined },
    notes: { booking_ref: b.booking_ref },
    theme: { color: "#0F4C5C" },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  rzp.open();
}
